import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './app/App';
import './index.scss';
import 'semantic-ui-css/semantic.min.css';
// import * as Sentry from '@sentry/browser';

// Sentry.init({ dsn: 'https://9e9137da17a24347a5e2b095788288c5@sentry.io/1433948' });
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
